import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getRestaurantBySlug } from "../api/restaurantsApi";
import ChatPage from "../pages/ChatPage/ChatPage";
import RestaurantNotFound from "../pages/RestaurantNotFound/RestaurantNotFound";
import type { Restaurant } from "../types/Restaurant";

export default function RestaurantChatRoute() {
    const { restaurantSlug, table } = useParams();
    const tableNumber = Number(table);

    const [restaurant, setRestaurant] = useState<Restaurant | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        setLoading(true);

        if (!restaurantSlug) {
            setRestaurant(null);
            setLoading(false);
            return;
        }

        getRestaurantBySlug(restaurantSlug)
            .then((r) => {
                if (!alive) return;
                setRestaurant(r);
            })
            .catch(() => {
                if (!alive) return;
                setRestaurant(null);
            })
            .finally(() => {
                if (!alive) return;
                setLoading(false);
            });

        return () => {
            alive = false;
        };
    }, [restaurantSlug]);

    if (loading) return <div style={{ padding: 20 }}>Loading...</div>;
    if (!restaurant) return <RestaurantNotFound />;
    if (!Number.isFinite(tableNumber) || tableNumber <= 0) {
        return <div style={{ padding: 20 }}>Invalid table number</div>;
    }

    return <ChatPage restaurant={restaurant} table={tableNumber} />;
}
